import { render, staticRenderFns } from "./logo-black.vue?vue&type=template&id=288bf192&"
import script from "./logo-black.vue?vue&type=script&lang=js&"
export * from "./logo-black.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports